export var ImportType;
(function (ImportType) {
    ImportType["TM"] = "TM";
    ImportType["SALTO"] = "SALTO";
})(ImportType || (ImportType = {}));
